import React, { Component } from 'react';

import './style.css';

export default class Contacts extends Component {
  render() {
    return(
      <div className='contacts'>
        <div className='contacts__background'>
          <div className='contacts__info'>
            <div className='contacts__title'>пишите, звоните!</div>
            <div className='contacts__item contacts__item_email'>
              org@happydev-lite.ru
              <span>Мы готовы ответить на любые вопросы</span>
            </div>
            <div className='contacts__item contacts__item_phone'>
              + 7 (909) 535 00 73
              <span>Анна Тарасенко, главный организатор</span>
            </div>
            <div className='contacts__item contacts__item_phone'>
              + 7 (913) 640 28 68
              <span>Алёна Борзунова, организатор</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout-page/blocks/contacts/Contacts.js